import React from 'react';
import Header from './Header';
import { useHistory } from 'react-router-dom';
import routes from '../router/routes';
import ContactFooter from './ContactFooter';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import SocialMedia from './SocialMedia';

const MainLayout = props => {

  const {
    location: {
      pathname: url
    }
  } = useHistory();

  return (
    <div className="main-layout">
      {props.loading &&
      <div className="loader">
        <Spin indicator={<LoadingOutlined style={{ fontSize: '6rem' }} spin />} />
      </div>
      }
      <Header/>
      <div style={{flexGrow: 1}}>
        {props.children}
      </div>
      {url === routes.ABOUT && (
        <SocialMedia />
      )}
      {url !== routes.CONTACT &&
        <>
          <ContactFooter waspPContent={url === routes.WASP_P}/>
        </>
      }
    </div>
  )
};

export default MainLayout;
